<template>
  <v-card>
    <v-card-text>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <th class="text-left">
              Core features
            </th>
            <th class="text-left">
              Basic
            </th>
            <th class="text-left">
              Premium
            </th>
          </thead>
          <tbody>
            <tr
              v-for="item in features"
              :key="item.name"
            >
              <td>{{ item.name }}</td>
              <td>{{ item.free }}</td>
              <td>{{ item.paid }}</td>
            </tr>
            <tr v-if="profile && !profile.premium">
              <td />
              <td>
                <v-btn
                  @click="$emit('createFreeAccount')"
                >
                  Sign-in/Create account
                </v-btn>
              </td>
              <td>
                <plan-checkout-button
                  v-if="user && user.email"
                  plan="yearly"
                />
                <v-btn
                  v-else
                  @click="$emit('createPaidAccount', 'yearly')"
                >
                  $0.99/month (billed yearly)
                </v-btn>
                <plan-checkout-button
                  v-if="user && user.email"
                  plan="monthly"
                />
                <v-btn
                  v-else
                  @click="$emit('createPaidAccount', 'monthly')"
                >
                  $1.39/month (billed monthly)
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn
        color="primary"
        text
        @click="$emit('close')"
      >
        Close
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapState } from 'vuex';

import PlanCheckoutButton from '@/components/PlanCheckoutButton.vue';

const check = '✓';

export default {
  name: 'PlanOptions',
  components: {
    PlanCheckoutButton,
  },
  data() {
    return {
      features: [
        {
          name: 'Easy and secure sharing',
          free: check,
          paid: check,
        },
        {
          name: 'Anytime, anywhere access',
          free: check,
          paid: check,
        },
        {
          name: '256-bit AES encryption',
          free: check,
          paid: check,
        },
        {
          name: 'Storage',
          free: '1 GB',
          paid: '50 GB',
        },
        {
          name: 'Number of scans',
          free: '1',
          paid: '20',
        },
        {
          name: '2-dimensional image viewing',
          free: check,
          paid: check,
        },
        {
          name: '3-dimensional image viewing',
          free: check,
          paid: check,
        },
        {
          name: 'Priority e-mail support',
          free: '-',
          paid: check,
        },
        {
          name: 'Phone support Mon-Fri 9-5pm PT',
          free: '-',
          paid: check,
        },
      ],
    };
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('profile', ['profile']),
  },
};
</script>
